export function EmptyState({ message = 'No records found.' }: { message?: string }) {
  return <div className="text-center text-muted py-4">{message}</div>;
}
